var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelmetSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544 280.891C544 191.723 482.166 115.473 404.389 83.527L352 174.223V49.777C352 39.914 344.084 32 334.223 32H241.777C231.916 32 224 39.914 224 49.777V174.223L171.611 83.527C93.834 115.473 32 191.723 32 280.891V352H544V280.891ZM574.688 393.656C572.156 387.812 566.375 384 560 384H16C9.625 384 3.844 387.812 1.313 393.656C-1.219 399.531 -0.031 406.344 4.375 411C7.031 413.812 72.031 480 288 480S568.969 413.812 571.625 411C576.031 406.344 577.219 399.531 574.688 393.656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmetSafety);
export default __webpack_public_path__ + "static/media/helmet-safety.703cb54127c2e160ced92797af328cdc.svg";
export { ForwardRef as ReactComponent };